import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { APIManager, DeductionType, FlowDataRule, FlowDataService, PaymentMethodService, PayMethod, PayType, ServiceService, Invoice } from '@flashvpn-io/web-core';
import { BehaviorSubject, filter, map, tap } from 'rxjs';
import { WebUIService } from '../../web-ui.service';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.css']
})
export class SubscriptionComponent implements OnInit {
  @Input() excludePayType: PayType[] = [];

  protected readonly DeductionType = DeductionType;

  public selectedPlan$: BehaviorSubject<FlowDataRule | null> = new BehaviorSubject<FlowDataRule | null>(null);

  public loading = false;

  public submitted = false;

  filteredPayMethods$: BehaviorSubject<PayMethod[]> = new BehaviorSubject<PayMethod[]>([]);

  active: string = '';
  payment: string = '';

  payments: PayMethod[] = []; // Import from mocks

  private baseRule = {
    "id": 1,
    "data": 10,
    "unit": "G",
    "amount": 5,
    "gift": 0,
    "description": "10G"
  };

  constructor(public flowDataService: FlowDataService,
    public serviceService: ServiceService,
    public apiManager: APIManager,
    public paymentMethodService: PaymentMethodService,
    public router: Router,
    public appService: WebUIService
  ) { }
  ngOnInit(): void {
    this.flowDataService.flowData$
      .pipe(
        filter((data) => data.length > 0),
        tap((data) => this.selectedPlan$.next(data[0]))
      )
      .subscribe(data => {
        this.baseRule = data[0];
      });
    this.paymentMethodService.paymentMethods$
      .pipe(
        filter((payMethods) => payMethods !== null && payMethods.length > 0),
        map((payMethods) => payMethods.filter((method) => !this.excludePayType.includes(method.payType)))
      )
      .subscribe((filteredMethods) => {
        this.filteredPayMethods$.next(filteredMethods as PayMethod[]);
      });
  }

  selectPlan(plan: FlowDataRule) {
    this.selectedPlan$.next(plan);
  }

  formatDate(date: string): string {
    return date ? new Date(date).toISOString() : "";
  }

  calculateDaysFromToday(targetDate: string): number {
    if (!targetDate) {
      return 0;
    }
    const today = new Date();
    const target = new Date(targetDate);
    const diffInTime = target.getTime() - today.getTime();
    const diffInDays = Math.floor(diffInTime / (1000 * 60 * 60 * 24));
    return diffInDays < 0 ? 0 : diffInDays;
  }

  async buy() {
    this.submitted = true;
    const currentMethod = this.paymentMethodService.currentMethod$.value;
    try {
      const postRule = {
        type: "flow",
        amount: this.selectedPlan$.value?.amount ?? 0,
        ruleId: this.selectedPlan$.value?.id ?? 0,
        serviceId: this.serviceService.currentService$.value.id,
      };
      const invoice = await this.apiManager.createFlowInvoice(postRule).toPromise();
      // TODO: deduction page
      // if (this.deductionComponent.deductionAmount$.value > 0) {
      //   if (this.deductionComponent.currentDeduction$.value === DeductionType.balance) {
      //     await this.apiManager.deductionInvoice(invoice, this.deductionComponent.deductionAmount$.value, null, null, null, true).toPromise();
      //   }
      // }
      if (invoice) {
        const data = await this.apiManager.payInvoice(invoice, currentMethod.payType, "").toPromise();
        if (data.redirect_url !== undefined) {
          if (this.appService.isAndroid() || this.appService.isIOS()) {
            window.location.href = data.redirect_url;
          } else {
            window.open(data.redirect_url);
            this.router.navigate(["status"], { queryParams: { invoiceId: invoice.id } });
          }
        }
      }
    }
    catch (e: any) {
      console.log(e);
      this.appService.snackUp(e?.error?.message || "支付失败，我们遇到了一些问题，请重试或联系客服");
      this.submitted = false;
    }
  }


  setCurrentMethod($event: any) {
    this.paymentMethodService.currentMethod$.next($event);
  }

  protected readonly PayType = PayType;

  setActive(tarif: string): void {
    this.active = tarif;
  }


  calculateDiscount(rule: any): string {
    const basePricePerUnit = this.baseRule.amount / this.baseRule.data;
    const currentPricePerUnit = rule.amount / rule.data;

    if (currentPricePerUnit < basePricePerUnit) {
      return `${(basePricePerUnit - currentPricePerUnit) / basePricePerUnit * 100}`;
    } else {
      return '0';
    }
  }
} 